<template>
  <div
    v-if="showModal"
    class="location-modal-container"
    role="dialog"
    aria-label="Required location popup"
  >
    <div class="location-modal" role="presentation">
      <img src="../assets/location_icon.png" alt="" role="presentation">
      <h1>Location Required</h1>
      <p>We need access to your location to provide tour recommendations.</p>
      <h4>Steps to Turn on Location Services</h4>
      <ol class="android-modal" v-if="device === 'Android'" role="presentation">
        <li>Open your device Settings.</li>
        <li>Tap Security & Location.</li>
        <li>Tap Location.</li>
        <li>Turn Use Location on.</li>
      </ol>
      <ul class="ios-modal" v-else-if="device === 'iOS'" role="presentation">
        <li>Go to Settings &gt; Privacy &gt; Location Services.</li>
        <li>Make sure that Location Services is turned on.</li>
        <li>Scroll down to find the {{ this.browserName }} app.</li>
        <li>Tap {{ this.browserName }} and select "While Using the App".</li>
      </ul>
      <button
        class="skip"
        @click="hideModal"
        @keypress.enter="hideModal"
      >Understood, skip this step</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'GeoLocationModal',
  data () {
    return {
      showModal: false,
      device: undefined,
      browserName: ''
    }
  },
  mounted () {
    this.device = this.detectDevice()
    this.browserName = this.getBrowserName()
  },
  computed: mapState(['positionError']),
  methods: {
    ...mapMutations(['setPositionError']),
    detectDevice: function () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      }

      if (/android/i.test(userAgent)) {
        return 'Android'
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }

      return undefined
    },
    getBrowserName: function () {
      // http://www.javascripter.net/faq/browsern.htm
      var nAgt = navigator.userAgent
      var browserName = navigator.appName

      if ((nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera'
      } else if ((nAgt.indexOf('Opera')) !== -1) {
        browserName = 'Opera'
      } else if ((nAgt.indexOf('MSIE')) !== -1) {
        browserName = 'Microsoft Internet Explorer'
      } else if ((nAgt.indexOf('Chrome')) !== -1) {
        browserName = 'Chrome'
      } else if ((nAgt.indexOf('Safari')) !== -1) {
        browserName = 'Safari'
      } else if ((nAgt.indexOf('Firefox')) !== -1) {
        browserName = 'Firefox'
      } else if ((nAgt.lastIndexOf(' ') + 1) < (nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring((nAgt.lastIndexOf(' ') + 1), nAgt.lastIndexOf('/'))
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
          browserName = navigator.appName
        }
      }
      return browserName
    },
    hideModal (event) {
      this.showModal = false
      this.$nextTick(() => {
        if (event.pointerType === "mouse" || (event.type === 'keypress' && event.keyCode === 13) ) {
          this.$focusOutsidePopup()
        }
      })
    }
  },
  watch: {
    positionError: {
      handler: function (newError, oldError) {
        if (newError !== undefined) {
          this.showModal = true
          this.$nextTick(() => this.$focusInsidePopup())
        }
      },
      immediate: true
    }
  }
}
</script>
